import { useEffect, useState, useRef } from 'react'
import { Box, Body, Icon } from '..'
import './Input.scss'

export const Input = ({
  name, title, description, leftIcon, leftIconAction, rightIcon, rightIconAction, iconSize = 24, disabled, error,
  textAlign = 'left', type = 'text', maxLength, small, dark, value, onChange, alt, onInputFocus, selectTextOnFocus,
  multiline, readOnly, ...props
}) => {
  const [focused, setFocused] = useState(false)

  const inputRef = useRef()
  const focusInput = () => {
    if(!readOnly) {
      setFocused(true)
      inputRef.current?.focus()
    }
  }

  useEffect(() => {
    const input = inputRef.current
    if (!input) return

    const handleFocus = () => {
      setFocused(true)
      if(onInputFocus){ // onFocus is already used by forms input
        onInputFocus()
      }
      if(selectTextOnFocus){
        input.select()
      }
    }
    const handleBlur = () => setFocused(false)

    input.addEventListener("focus", handleFocus)
    input.addEventListener("blur", handleBlur)

    return () => {
      input.removeEventListener("focus", handleFocus)
      input.removeEventListener("blur", handleBlur)
    }
  }, [onInputFocus, selectTextOnFocus])

  const iconColor = () => disabled
    ? 'var(--darkgrey)'
    : dark
      ? alt
        ? 'white'
        : 'black'
      : alt
        ? 'black'
        : focused
          ? 'black'
          : 'white'

  return <Box
    className={`input-outer-container${error ? ' error' : ''}${dark ? ' dark' : ''}${alt ? dark ? '-alt' : ' alt' : ''}`}
    column
  >
    {title &&
      <Body
        alt
        weight={600}
        color={disabled ? 'var(--darkgrey)' : ''}
      >
        {title}
      </Body>
    }
    <Box
      className={`input-container${small ? ' small' : ''}`}
      justifyContent="space-between"
      alignItems="center"
      gap={8}
      height={!multiline && 48}
      radius={multiline ? 16 : 60}
      onClick={focusInput}
    >
      {leftIcon &&
        <Box
          height={32}
          width={32}
          justifyContent="space-between"
          alignItems="center"
          onClick={() => {
            if(onInputFocus){
              onInputFocus()
            }
            if(leftIconAction) {
              leftIconAction()
            }
          }}
          cursor={leftIconAction && 'pointer'}
        >
          <Icon
            icon={leftIcon}
            fill={iconColor()}
            size={iconSize}
          />
        </Box>
      }

      {multiline
        ? <textarea
            name={name}
            disabled={disabled}
            ref={inputRef}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            rows={6}
            style={{
              textAlign: textAlign,
              paddingTop: 16,
              paddingBottom: 16
            }}
            readOnly={readOnly}
            {...props}
          />
        : <input
            name={name}
            disabled={disabled}
            ref={inputRef}
            value={value}
            onChange={onChange}
            type={type}
            maxLength={maxLength}
            style={{
              textAlign: textAlign
            }}
            readOnly={readOnly}
            {...props}
          />
      }

      {rightIcon &&
        <Box
          height={iconSize}
          width={iconSize}
          justifyContent="space-between"
          alignItems="center"
          onClick={() => {
            if(onInputFocus){
              onInputFocus()
            }
            if(rightIconAction) {
              rightIconAction()
            }
          }}
          cursor={rightIconAction && 'pointer'}
        >
          <Icon
            icon={rightIcon}
            fill={iconColor()}
            size={iconSize}
          />
        </Box>
      }
    </Box>

    {description &&
      <Body
        className={(error && !disabled ? ' error-text' : '')}
        color={disabled ? 'var(--darkgrey)' : ''}
      >
        {description}
      </Body>
    }
  </Box>
}
